import { useRouter } from 'vue-router';

// 监听localStorage中token的变化
export function setupTokenListener() {
  const router = useRouter();
  
  // 监听storage事件（跨标签页通信）
  window.addEventListener('storage', (e) => {
    if (e.key === 'token' && e.newValue) {
      // 当检测到token被设置时，自动跳转到主页
      router.push('/standard');
    }
  });
  
  // 监听当前页面的localStorage变化
  const originalSetItem = localStorage.setItem;
  localStorage.setItem = function(key: string, value: string) {
    originalSetItem.apply(this, [key, value]);
    
    if (key === 'token' && value) {
      // 触发自定义事件
      window.dispatchEvent(new CustomEvent('tokenSet', { detail: { token: value } }));
    }
  };
}

// 检查并处理URL中的token参数
export function handleUrlToken() {
  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get('token');
  
  if (urlToken) {
    localStorage.setItem('token', urlToken);
    
    // 清除URL中的token参数
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete('token');
    window.history.replaceState({}, '', newUrl.toString());
    
    return true;
  }
  
  return false;
}

// 生成带token的跳转链接
export function generateTokenUrl(baseUrl: string, token: string): string {
  const url = new URL(baseUrl);
  url.searchParams.set('token', token);
  return url.toString();
} 